import { render, staticRenderFns } from "./AggregationMode.vue?vue&type=template&id=2307bf86&scoped=true&"
import script from "./AggregationMode.vue?vue&type=script&lang=ts&"
export * from "./AggregationMode.vue?vue&type=script&lang=ts&"
import style0 from "./AggregationMode.vue?vue&type=style&index=0&id=2307bf86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307bf86",
  null
  
)

export default component.exports